import { UploadCloudIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";

import type { useFileDropZone } from "../hooks/useFileDropZone";

interface DropZoneProps {
  dropZoneProps: ReturnType<typeof useFileDropZone>["dropZoneProps"];
  isDragging: boolean;
  onClick: () => void;
}

export function DropZone({
  dropZoneProps,
  isDragging,
  onClick,
}: DropZoneProps) {
  return (
    <div
      className={twMerge(
        "shrink-0 w-[274px] rounded-xl border border-border-secondary p-3xl h-[374px] grid place-items-center transition-colors duration-200",
        isDragging && "border-border-brand-solid border-2",
        "hover:bg-bg-primary-hover",
      )}
      onClick={onClick}
      {...dropZoneProps}
    >
      <div className="flex flex-col gap-lg items-center pointer-events-none">
        <div className="size-10 shrink-0 grid place-items-center rounded-md border border-border-secondary">
          <UploadCloudIcon className="text-fg-secondary" size={16} />
        </div>
        <div className="flex flex-col gap-xs text-center">
          <span className="text-sm font-regular text-text-tertiary">
            <span className="text-sm font-semibold text-button-tertiary-color-fg cursor-pointer">
              Click to upload
            </span>{" "}
            or drag and drop
          </span>
          <span className="text-text-secondary max-w-[181px] mx-auto text-xs font-regular">
            Upload your design files and source files here, to be submitted for
            Client&apos;s review and approval.
          </span>
        </div>
      </div>
    </div>
  );
}
